module.exports = __webpack_public_path__ + "static/media/p_inactive.85571fc9.png";